import { FORM_OPTIONS } from '@context/stock/buysell';

export const getAccountType = (orderDetail) => {
  return {
    ...FORM_OPTIONS.ACCOUNT_TYPE.find((v) => v.value === orderDetail?.account_type),
    orderTypes: [orderDetail?.order_type],
  };
};

export const getOrderType = (orderDetail) => {
  return FORM_OPTIONS.ORDER_TYPE.find((v) => v.key === orderDetail?.order_type);
};

export const getOrderPeriod = (orderDetail) => {
  return FORM_OPTIONS.ORDER_PERIOD.find((v) => v.value === orderDetail?.order_period);
};

export const getAutoThresholdComparator = (orderDetail) => {
  return FORM_OPTIONS.AUTO_THRESHOLD_COMPARATOR.find(
    (v) => v.value === orderDetail?.threshold_comparator
  );
};
